// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607281104/js/" + chunkId + "." + {"44":"2bbd66f6","225":"c695a2a9","481":"e0e7c4fc","486":"ac36d895","770":"4a99a5f7"}[chunkId] + ".0.24339120362551703.chunk.js";
};